import { FC, useCallback, useState } from 'react';
import { BrgButton, ButtonVariant } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import { useDispatch, useSelector } from 'react-redux';
import { useProfile } from '@brg/auth';
import { IconCloseMob } from 'shared/modals/SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';
import {
  CloseButton,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalHeaderRow,
  ModalTitle,
} from 'shared/modals/chooseAkiStatus/styles';
import { changeFtblClub } from 'shared/pages/teams/helpers/changeFtblClub';
import { updateFtblTeamMembership } from 'shared/pages/teams/helpers/updateFtblTeamMembership';

type FtblJoinClubModalProps = {
  mode: 'join' | 'change';
  targetTeamId: string;
  targetTeamName: string;
  currentClubName?: string;
};

export const FtblJoinClubModal: FC<FtblJoinClubModalProps> = ({
  mode,
  targetTeamId,
  targetTeamName,
  currentClubName,
}) => {
  const { t } = useTranslation();
  const modal = useModal();
  const dispatch = useDispatch();
  const profile = useProfile();
  const storedTeam = useSelector((store: { organizations: { team: any } }) => store.organizations.team);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = useCallback(() => {
    modal.hide();
  }, [modal]);

  const handleConfirm = () => {
    if (!profile?.accountId || !targetTeamId) {
      return;
    }

    setIsLoading(true);

    changeFtblClub({ teamId: targetTeamId })
      .then(() => updateFtblTeamMembership({
        dispatch,
        team: storedTeam,
        teamId: targetTeamId,
        accountId: profile.accountId,
        isJoin: true,
      }))
      .then(() => {
        modal.hide();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const title = mode === 'join'
    ? t('ftbl.team_page.join_modal_title', { club: targetTeamName })
    : t('ftbl.team_page.change_modal_title');

  const description = mode === 'join'
    ? t('ftbl.team_page.join_modal_description')
    : t('ftbl.team_page.change_modal_description', {
      currentClub: currentClubName,
      targetClub: targetTeamName,
    });

  const confirmLabel = mode === 'join'
    ? t('ftbl.team_page.join_club')
    : t('ftbl.team_page.change_club');

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{title}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <ModalDescription>{description}</ModalDescription>
      <ModalActions>
        <BrgButton
          variant={ButtonVariant.Filled}
          fullWidth
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {confirmLabel}
        </BrgButton>
      </ModalActions>
    </ModalBody>
  );
};

export default FtblJoinClubModal;
import { FC, useCallback, useState } from 'react';
import { BrgButton, ButtonVariant } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import { useDispatch, useSelector } from 'react-redux';
import { useProfile } from '@brg/auth';
import { IconCloseMob } from 'shared/modals/SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';
import {
  CloseButton,
  ModalActions,
  ModalBody,
  ModalDescription,
  ModalHeaderRow,
  ModalTitle,
} from 'shared/modals/chooseAkiStatus/styles';
import { changeFtblClub } from 'shared/pages/teams/helpers/changeFtblClub';
import { updateFtblTeamMembership } from 'shared/pages/teams/helpers/updateFtblTeamMembership';

type FtblJoinClubModalProps = {
  mode: 'join' | 'change';
  targetTeamId: string;
  targetTeamName: string;
  currentClubName?: string;
};

export const FtblJoinClubModal: FC<FtblJoinClubModalProps> = ({
  mode,
  targetTeamId,
  targetTeamName,
  currentClubName,
}) => {
  const { t } = useTranslation();
  const modal = useModal();
  const dispatch = useDispatch();
  const profile = useProfile();
  const storedTeam = useSelector((store: { organizations: { team: any } }) => store.organizations.team);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = useCallback(() => {
    modal.hide();
  }, [modal]);

  const handleConfirm = () => {
    if (!profile?.accountId || !targetTeamId) {
      return;
    }

    setIsLoading(true);

    changeFtblClub({ teamId: targetTeamId })
      .then(() => updateFtblTeamMembership({
        dispatch,
        team: storedTeam,
        teamId: targetTeamId,
        accountId: profile.accountId,
        isJoin: true,
      }))
      .then(() => {
        modal.hide();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const title = mode === 'join'
    ? t('ftbl.team_page.join_modal_title', { club: targetTeamName })
    : t('ftbl.team_page.change_modal_title');

  const description = mode === 'join'
    ? t('ftbl.team_page.join_modal_description')
    : t('ftbl.team_page.change_modal_description', {
      currentClub: currentClubName,
      targetClub: targetTeamName,
    });

  const confirmLabel = mode === 'join'
    ? t('ftbl.team_page.join_club')
    : t('ftbl.team_page.change_club');

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{title}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <ModalDescription>{description}</ModalDescription>
      <ModalActions>
        <BrgButton
          variant={ButtonVariant.Filled}
          fullWidth
          onClick={handleConfirm}
          disabled={isLoading}
        >
          {confirmLabel}
        </BrgButton>
      </ModalActions>
    </ModalBody>
  );
};

export default FtblJoinClubModal;
